<template>
    <ion-page class="ion-page"  id="main">
        <default-header/>

        <ion-content fullscreen>
            <ion-list lines="none">
                <ion-item-sliding v-for="draft in drafts" :key="draft.id" @click="openDraft(draft.id)" button>
                    <ion-item>
                        <ion-avatar slot="start">
                            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+"
                                 alt="">
                        </ion-avatar>
                        <ion-label>
                            <h3>{{ draft.subject }}</h3>
                        </ion-label>
                        <ion-badge slot="end">{{ draft.sent_at }}</ion-badge>
                    </ion-item>
                    <ion-item-options side="start">
                        <ion-item-option @click="openDraft(draft.id)">Actie links</ion-item-option>
                    </ion-item-options>
                    <ion-item-options side="end">
                        <ion-item-option @click="openDraft(draft.id)">Actie rechts</ion-item-option>
                    </ion-item-options>
                </ion-item-sliding>
            </ion-list>
            <ion-menu-button menu="main"/>
        </ion-content>
    </ion-page>
</template>

<script>
    import {DRAFTS_MUTATION} from "../../../const/mutation-types";
    import DefaultHeader from "../../nav/DefaultHeader.vue";

    export default {
        components: {DefaultHeader},
        computed: {
            drafts() {
                return this.$store.getters.drafts;
            }
        },
        methods: {
            openDraft(id) {
                this.$router.push({name: 'draft', params: {id}})
            },
            retrieveDrafts() {
                this.$http
                    .get('/drafts')
                    .then(response => this.$store.commit(DRAFTS_MUTATION, response.data))
                    .catch(error => window.console.error(error));
            },
        },
        data() {
            return {
                unwatch: null,
            }
        },
        destroyed() {
            this.unwatch();
        },
        created() {
            this.unwatch = this.$store.watch(
                (state) => state.user,
                (value) => {
                    if (value) {
                        this.retrieveDrafts();
                    }
                }
            );

            if (!this.drafts.length && this.$store.getters.authed) {
                this.retrieveDrafts();
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
